<template>
    <span class="icon-wrapper">
        <!-- <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none">
            <polygon points="8,4 12,8 4,8" :fill="colorIconAsc"/>
        </svg>
        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none">
           
            <polygon points="4,10 12,10 8,14" :fill="colorIconDesc"/>
        </svg> -->
        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none">
            <polygon points="8,4 12,8 4,8" :fill="colorIconAsc"/>
            <polygon points="4,10 12,10 8,14" :fill="colorIconDesc"/>
        </svg>
    </span>
</template>
<script>
export default{
    props:{
        iconColor:{
            type: String,
        },
        sortOrder: String,
    }, 
    computed: {
        colorIconAsc(){
            return this.sortOrder == 'asc' ? 'currentColor' : '#C2C5CF'
        },
        colorIconDesc(){
            return this.sortOrder == 'desc' ? 'currentColor' : '#C2C5CF'
        }
    }
}

</script>

<style scoped>
.icon-wrapper {
  display: inline-block;
}
</style>